<template>
  <a
    v-if="this.url"
    :href="url"
    :class="`app-button__container${shadow ? '_shadow' : ''}`"
    :style="{ color, backgroundColor }"
    target="_blank"
  >
    {{ title }}
  </a>
  <router-link
    v-else-if="route"
    :to="route"
    :style="{ color, backgroundColor }"
  >
    {{ title }}
  </router-link>
  <div
    v-else
    :class="`app-button__container${shadow ? '_shadow' : ''}`"
    :style="{ color, backgroundColor }"
    @click.native="handleClick"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    url: {
      type: String,
      default: undefined
    },
    route: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    backgroundColor: {
      type: String,
      default: '#ff8511'
    },
    shadow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    identifier () {
      return this.title.toLowerCase().replace(/^[A-z]/, '')
    }
  },
  methods: {
    handleClick () {
      this.$emit('click', '')
      // eslint-disable-next-line
      console.debug(`click:  ${this.identifier}`);
    }
  }
}
</script>

<style scoped>
.app-button__container,
.app-button__container_shadow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1rem;
  padding: 1.875rem 3rem;
  box-sizing: border-box;
  width: fit-content;

  font-family: "Avenir-Heavy";
  font-size: 0.9375rem;
  color: #fff;
  letter-spacing: 0;
  text-align: center;

  margin-top: 2px;
  margin-bottom: 2px;
  border: 2px solid rgba(255, 255, 255, 0);
  border-radius: 0.625rem;

  cursor: pointer;

  transition: all 300ms ease-out;
  transform: scale(1);
  filter: brightness(1);
  user-select: none;
}

.app-button__container_shadow {
  box-shadow: 0 0.8rem 1.6rem 0.125rem rgba(0, 0, 0, 0.15);
}

.app-button__container::selection,
.app-button__container_shadow::selection {
  background-color: #ffffff;
}

.app-button__container::-moz-selection,
.app-button__container_shadow::-moz-selection {
  background-color: #ffffff;
}

.app-button__container:hover,
.app-button__container_shadow:hover {
  transform: scale(1.1);
  filter: brightness(1.05);

  border: 2px solid #fff;
  border-radius: 0.625rem;
  margin-top: 0;
  margin-bottom: 0;
}

a {
  text-decoration: none;
}

@media screen and (max-width: 775px) {
  .app-button__container,
  .app-button__container_shadow {
    margin-top: 0.5rem 0;
  }
}
</style>
